export function CodeIcon(props) {
  return (
    <svg
      width="3.6rem"
      height="2.7rem"
      viewBox="0 0 36 27"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="code-icon-a" d="M6.59789683e-16 0L34.9135429 0 34.9135429 26 6.59789683e-16 26z" />
      </defs>
      <g
        transform="translate(-594 -1688) translate(548 1668.92) translate(46.886 19.4)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <mask id="code-icon-b" fill="#fff">
          <use xlinkHref="#code-icon-a" />
        </mask>
        <path
          d="M20.699.033c.597.15.96.755.81 1.35l-5.944 23.772a1.115 1.115 0 01-2.162-.54L19.348.846c.15-.598.754-.962 1.352-.812m-11.37 4.75a1.115 1.115 0 010 1.576L2.69 13l6.64 6.64a1.115 1.115 0 01-1.574 1.576L.326 13.788a1.115 1.115 0 010-1.576l7.43-7.429a1.113 1.113 0 011.574 0m16.254 0a1.113 1.113 0 011.574 0l7.43 7.429a1.115 1.115 0 010 1.576l-7.43 7.428a1.115 1.115 0 01-1.575-1.576l6.64-6.64-6.64-6.64a1.115 1.115 0 010-1.577"
          fill="#FFF"
          mask="url(#code-icon-b)"
        />
      </g>
    </svg>
  );
}

export function AlertIcon(props) {
  return (
    <svg width="2.3rem" height="2rem" viewBox="0 0 23 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M559.455 1801.284a1.236 1.236 0 00-2.12 0l-8.375 13.959a1.237 1.237 0 001.059 1.873h16.752c.96 0 1.555-1.048 1.06-1.873l-8.376-13.96zm-3.392-.763c1.056-1.761 3.608-1.761 4.664 0l8.377 13.96c1.088 1.812-.219 4.119-2.333 4.119H550.02c-2.114 0-3.42-2.307-2.332-4.12l8.376-13.959zm2.332 4.725c.41 0 .742.333.742.742v3.957a.742.742 0 01-1.484 0v-3.957c0-.41.333-.742.742-.742zm0 6.925c.41 0 .742.332.742.741v.99a.742.742 0 01-1.484 0v-.99c0-.41.333-.741.742-.741z"
        transform="translate(-547 -1799)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function CoinsIcon(props) {
  return (
    <svg width="4rem" height="4rem" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M483.955 2506.17c-.447.44-.598.828-.598 1.146 0 .317.15.703.598 1.144.452.445 1.154.89 2.093 1.28 1.88.783 4.537 1.29 7.524 1.29 2.984 0 5.644-.507 7.523-1.29.938-.39 1.64-.835 2.091-1.28.45-.44.6-.827.6-1.144 0-.318-.15-.706-.6-1.146-.451-.446-1.153-.89-2.091-1.28-1.88-.784-4.539-1.289-7.523-1.289-2.987 0-5.644.505-7.524 1.29-.94.39-1.641.833-2.093 1.279zm19.831 4.206c-.568.41-1.239.77-1.98 1.08-2.154.898-5.066 1.43-8.234 1.43-3.17 0-6.082-.532-8.239-1.43-.737-.31-1.411-.67-1.976-1.08v4.368c0 .318.15.704.598 1.144.452.446 1.154.89 2.093 1.282 1.88.781 4.537 1.288 7.524 1.288 2.984 0 5.644-.507 7.523-1.288.938-.392 1.64-.836 2.091-1.282.45-.44.6-.826.6-1.144v-4.368zm0 7.429c-.568.41-1.239.77-1.98 1.079-2.154.899-5.066 1.432-8.234 1.432-3.17 0-6.082-.533-8.239-1.432-.737-.309-1.411-.669-1.976-1.08v4.369c0 .317.15.704.598 1.144.452.445 1.154.89 2.093 1.281 1.88.782 4.537 1.289 7.524 1.289 1.27 0 2.488-.093 3.612-.26.648-.776 1.617-1.41 2.741-1.91 1.1-.488 2.412-.876 3.861-1.141v-4.771zm1.857 4.509v-14.998c0-.966-.473-1.8-1.153-2.469-.676-.666-1.608-1.223-2.684-1.673-2.154-.897-5.066-1.43-8.234-1.43-3.17 0-6.082.533-8.239 1.43-1.073.45-2.005 1.007-2.68 1.673-.68.669-1.153 1.503-1.153 2.469v22.285c0 .964.474 1.798 1.154 2.468.674.667 1.606 1.222 2.68 1.672 2.156.899 5.068 1.432 8.238 1.432.956 0 1.89-.05 2.785-.141v.14c0 .965.474 1.798 1.154 2.469.674.667 1.606 1.222 2.68 1.671 2.156.9 5.068 1.432 8.238 1.432 3.168 0 6.08-.533 8.234-1.432 1.076-.45 2.008-1.004 2.684-1.671.68-.67 1.153-1.504 1.153-2.468v-7.429c0-.966-.473-1.8-1.153-2.468-.676-.667-1.608-1.224-2.684-1.673-2.154-.897-5.066-1.43-8.234-1.43-.96 0-1.893.048-2.786.14zm13 8.49v4.369c0 .317-.15.704-.6 1.144-.451.445-1.153.89-2.09 1.281-1.88.782-4.54 1.289-7.524 1.289-2.986 0-5.644-.507-7.523-1.289-.94-.392-1.642-.836-2.093-1.281-.448-.44-.598-.827-.598-1.144v-4.368c.564.41 1.238.77 1.976 1.079 2.156.899 5.068 1.432 8.238 1.432 3.168 0 6.08-.533 8.234-1.432a9.853 9.853 0 001.98-1.08zm-20.428-3.06c0 .318.15.704.598 1.144.45.446 1.153.89 2.093 1.282 1.879.781 4.537 1.288 7.523 1.288 2.984 0 5.644-.507 7.523-1.288.938-.392 1.64-.836 2.091-1.282.45-.44.6-.826.6-1.144 0-.317-.15-.706-.6-1.146-.451-.445-1.153-.89-2.09-1.28-1.88-.783-4.54-1.288-7.524-1.288-1.26 0-2.463.089-3.58.252-1.633.242-3.058.64-4.172 1.133-1.13.504-1.857 1.068-2.21 1.59-.182.273-.252.518-.252.74zm-1.858 5.42v-5.42c0-.048 0-.095.004-.141a27.68 27.68 0 01-2.79.141c-3.17 0-6.081-.533-8.238-1.432-.737-.308-1.411-.668-1.976-1.079v4.368c0 .318.15.704.598 1.144.452.446 1.154.89 2.093 1.282 1.88.782 4.537 1.289 7.524 1.289.964 0 1.898-.054 2.785-.153z"
        transform="translate(-481 -2501)"
        fill="#FFF"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  );
}
